import axios from "axios";

import { API } from "../../constants";
import {
  TypeAssessmentAttempt,
  TypeAssessmentInfo,
  TypeNotification,
  TypeQuestionAttempt,
} from "../../types";

// fetches topic list based on grade, subject and medium
export const getTopics = (
  gradeId: number,
  subjectId: number,
  medium: number
) => {
  return axios.get(
    API + `custom/topic?subject=${subjectId}&grade=${gradeId}&medium=${medium}`
  );
  // return axios.get(API + `custom/topic?subject=${subjectId}&grade=${gradeId}&medium=1`);
};

// fetches question list for assessment/homework
export const getQuestions = (
  gradeId: number,
  subjectId: number,
  topicId: string,
  searchQuery?: string
) => {
  return axios.get(
    API +
      `items/question?filter[grade.id]=${gradeId}&filter[subject.id]=${subjectId}&filter[topic.id][in]=${topicId}&q=${
        searchQuery || ""
      }&fields=*.*`
  );
  // grade_subject_topic_subtopic_question
};

// fetch student list for particular grade-section to create a new assessment/homework
export const getAllStudents = (gradeSectionId: number) => {
  return axios.get(
    API +
      `items/student_profile_grade_section?filter[grade_section_id]=${gradeSectionId}&fields=id,student_profile_id.user`
  );
};

/* 
    CREATE TEACHER ASSESSMENT/HOMEWORK STARTS
*/
// add a new homework-assessment
export const addHomeworkAssessment = (assessmentData: TypeAssessmentInfo) => {
  return axios.post(API + "items/assessment", assessmentData);
};

// add questions to assesment/homework
export const addQuestionsToAssessment = (
  questionList: { assessment_id: number; question_id: number }[]
) => {
  return axios.post(API + "items/assessment_question", questionList);
};

// create assessment attempt for all available student of a particular grade-section
export const postAssessmentForAllStudents = (list: TypeAssessmentAttempt[]) => {
  return axios.post(API + "items/assessment_attempted", list);
};

// create question attempt for all available students of a particular grade-section
export const createQuestionAttemptsForAllStudents = (
  questionAttemptList: TypeQuestionAttempt[]
) => {
  return axios.post(
    API + "items/question_attempted_student",
    questionAttemptList
  );
};

// create new notification for students of assigned grade-section when a new assessment/homework is available
export const createNotification = (list: TypeNotification[]) => {
  return axios.post(API + "items/notification", list);
};

/* 
    CREATE TEACHER ASSESSMENT/HOMEWORK ENDS
*/

/* 
    CREATE STATE LEVEL ASSESSMENT STARTS
*/
// fetch grades based on medium
export const getGradeListBasedOnMedium = (medium: number) => {
  return axios.get(
    API + `items/grade?filter[medium]=${medium}&fields=id,medium,name`
  );
};

// fetch subjects based on grade
export const getSubjectBasedOnGradeMedium = (
  grade_id: number,
  medium: number
) => {
  return axios.get(
    API +
      `items/grade_subject_topic_subtopic?filter[grade]=${grade_id}&filter[medium]=${medium}&fields=id,subject.id,subject.name`
  );
};

// fetch all available students for particular grade based on grade
export const getStudents = (grade_id: number) => {
  return axios.get(
    API +
      `items/student_profile_grade_section?filter[grade_section_id.grade]=${grade_id}&fields=id,student_profile_id.user,grade_section_id.grade,grade_section_id.session.*`
  );
};
/* 
    CREATE STATE LEVEL ASSESSMENT ENDS
*/

// fetch all assessments
export const getAllAssessments = (
  teacherId: number,
  gradeId: number,
  subjectId: number,
  category: string
) => {
  return axios.get(
    API +
      `items/assessment?filter[assigned_by]=${teacherId}&filter[category]=${category}
        &filter[grade]=${gradeId}&filter[subject]=${subjectId}&sort=-start_date&fields=*.*.*`
  );
};

// fetch particular assessment details
export const getAssessmentDetails = (session: number, assessmentId: number) => {
  return axios.get(
    // API + `items/assessment?filter[id]=${assessmentId}&fields=*.*.*&single=1`
    `${API}custom/stats_admin/state/assessment/details?session=${session}&assessment_id=${assessmentId}`
  );
};

// fetch total number of students for particular assessment
export const getNoOfStudents = (gradeSectionId: number) => {
  return axios.get(
    API +
      `items/student_profile_grade_section?filter[grade_section_id]=${gradeSectionId}&meta=filter_count&limit=0`
  );
};

// fetch data to claculate stats for a particular assessment
export const getAssessmentStats = (assessmentId: number) => {
  return axios.get(
    API +
      `items/assessment_attempted?filter[assessment]=${assessmentId}
        &fields=id,assessment,current_status,total_score,total_bonus,student.id,student.first_name,student.last_name,student.srn_no,student.status,student.avatar.*`
  );
};

export const postNewAssessment = (body: TypeAssessmentInfo) => {
  return axios.post(`${API}custom/assessment`, body);
};
export const postNewAssessmentNotification = (
  subject: number | null,
  topic_ids: (number | null)[],
  category: string | null,
  assessmentId: number
) => {
  return axios.post(`${API}custom/assessment/sendNotifications`, {
    subject,
    topic_ids,
    category,
    assessmentId,
  });
};
